<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.items.length">
                <div :class="[this.gridClassArray, 'link-buttons', 'theme-accent-border-color']">
                  <template v-for="(item, index) in contents.items">
                    <template v-if="item.anchor.text">
                      <div>
                        <span class="link-button theme-accent-border-color theme-accent-bg-color-hover px4 py2 block fit-width bold">
                          <span class="before theme-accent-color">{{ item.before.text }}</span>
                          <span class="anchor">{{ item.anchor.text }}</span>
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <span class="link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold">ページを選択してください</span>
                      </div>
                    </template>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">リンクを追加してください</span>
                </div>
              </template>
            </div>
          </section>
        </div>
      </div>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="内部リンク" label-width="110px">
          <template v-for="(item, index) in contents.items">
            <div class="flex">
              <div class="flex column justify-center fit-width mb1">
                <el-input class="width-100" v-model="item.anchor.text" auto-complete="off" placeholder="リンクボタンのテキスト"></el-input>
                <el-input class="width-100" v-model="item.before.text" auto-complete="off" placeholder="リンクボタンの補助テキスト"></el-input>
                <div class="flex justify-between">
                  <el-select class="width-50" value-key="link" v-model="contents.items[index].componentId" placeholder="アンカーリンク先を選択" style="display:inline-block;">
                    <el-option class="el-opp"
                      v-for="(comp,compIndex) in components"
                      :key="compIndex"
                      :label="'上から' + (compIndex + 1) + '番目の' + comp.meta.title"
                      :value="componentId(comp)">
                    </el-option>
                  </el-select>
                  <el-button class="width-20 ml1" @click="onDeleteLink(index)">リンクの削除</el-button>
                </div>
              </div>
            </div>
          </template>
          <el-button class="my1" @click="onAddLink">リンクボタンの追加</el-button>
        </el-form-item>
        <el-form-item label="スマホサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.s" controls-position="right" :min="1" :max="2"></el-input-number><span class="pl4">最大2まで</span>
        </el-form-item>
        <el-form-item label="タブレットサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.m" controls-position="right" :min="1" :max="3"></el-input-number><span class="pl4">最大3まで</span>
        </el-form-item>
        <el-form-item label="デスクトップサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.l" controls-position="right" :min="1" :max="4"></el-input-number><span class="pl4">最大4まで</span>
        </el-form-item>
        <!-- <el-form-item label="リンクボタン間の余白" :label-width="labelWidth">
           <el-slider v-model="contents.layout.margin" :step="1" :min="0" :max="5"></el-slider>
        </el-form-item> -->
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import {getFontawesomeIcons} from '@/helpers'

export default {
  name: 'anchor-link-buttons-1',
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '20em',
      icons: getFontawesomeIcons()
    }
  },
  methods: {
    onAddLink: function () {
      this.contents.items.push({
        componentId: null,
        anchor: {
          text: 'リンクボタンのテキスト',
          color: ''
        },
        before: {
          text: '補助テキスト',
          color: ''
        }
      })
    },
    onDeleteLink: function (index) {
      this.contents.items.splice(index, 1)
    },
    /**
     * ページ内のコンポーネントの this._uid が変更されたら
     * イベントバスを通して contents.items の componentId を
     * 最新の that._uid が入るように更新する
     */
    updateComponentIds: function (that) {
      this.contents.items.forEach(item => {
        // 更新される前の _uid とitem.componentIdを比較する
        if (this.componentId(that.component) !== item.componentId) return
        // _uid が変更されたコンポーネントが contents.items に存在している場合
        const componentId = item.componentId
        if (process.env.NODE_ENV !== 'production') console.log(`%c${componentId} has been changed. Updating the ID...`, 'color: orange')
        item.componentId = this.componentId(that)
        if (process.env.NODE_ENV !== 'production') console.log(`%ccomponentId is updated: ${componentId} -> ${item.componentId}`, 'color: green')
        this.updateComponent()
      })
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const linkButtons = contents.items.reduce((acc, item, index) => {
        return acc + (`<div><span class="link-button theme-accent-border-color theme-accent-bg-color-hover px4 py2 block fit-width bold" role="button" tabindex="${index}" on="tap:${item.componentId}.scrollTo(duration=${contents.animation.duration})"><span class="before theme-accent-color">${item.before.text}</span><span class="anchor">${item.anchor.text}</span></span></div>`)
      }, '')

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <div class="${this.gridClass} link-buttons theme-accent-border-color">
            ${linkButtons}
          </div>
        </div>
      </section>`.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  mounted: function () {
    this.bus.$on('uid-updated', this.updateComponentIds)
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.native {
  @import './AnchorLinkButtons1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './AnchorLinkButtons1.s.scss';
}
.tablet,
.desktop {
  @import './AnchorLinkButtons1.m.scss';
}
.desktop {
  @import './AnchorLinkButtons1.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/AnchorLinkButtons1/AnchorLinkButtons1.vue